import { useSelector } from 'react-redux'

import { preview } from '@/components/form/preview'
import { selectTrafficTimeWindows } from '@/features/domain/traffic'

import { useComputeTimeWindowsValues } from '../../../hooks/useComputeTimeWindowsValues'
import { getDrivingTimeFactorLabel, isMultipleValues } from '../../../utils'
import { Header } from './components/Header'
import { useTexts } from './hooks/useTexts'
import { useTrafficAreas } from './hooks/useTrafficAreas'
import { useViewDetails } from './hooks/useViewDetails'

export function BulkView() {
  const timeWindows = useSelector(selectTrafficTimeWindows)
  const trafficAreas = useTrafficAreas()
  const { levels, timeWindowsLevels } = useViewDetails(trafficAreas)
  const timeWindowValues = useComputeTimeWindowsValues(timeWindows, timeWindowsLevels)
  const texts = useTexts()

  if (levels.length === 0) {
    return null
  }

  return (
    <preview.Root applyPendingFitMapOnMount header={<Header trafficAreas={trafficAreas} />}>
      <preview.Field label={texts.defaultDrivingTime}>
        {isMultipleValues(levels) ? texts.multipleValues : getDrivingTimeFactorLabel(levels[0])}
      </preview.Field>

      <preview.Divider />

      <preview.SectionTitle>{texts.TimeWindowsDrivingTime}</preview.SectionTitle>

      {timeWindowValues.map(val => (
        <preview.Field label={<preview.TimeWindow tw={val.key} />}>
          {isMultipleValues(val.values)
            ? texts.multipleValues
            : getDrivingTimeFactorLabel(val.values[0])}
        </preview.Field>
      ))}
    </preview.Root>
  )
}
